<template>
  <div class="block-allow-list-wrap">
    <t-tabs :items="tabNavItems" />
    <router-view> </router-view>
  </div>
</template>

<script>
import TTabs from "@/components/TTabs";

export default {
  name: "EndUserBlockAllowList",
  components: {
    TTabs,
  },
  data() {
    return {
      tabNavItems: this.$secondaryNav.endUserBlockAllowList(),
    };
  },
};
</script>
